import React from 'react';
import { defaultLangCode } from "../constants";
export var LocaleContext = /*#__PURE__*/React.createContext({
  locale: {},
  langCode: defaultLangCode
});
LocaleContext.displayName = 'LocaleContext';
LocaleContext.__KONTUR_REACT_UI__ = 'LocaleContext';